import(/* webpackMode: "eager", webpackExports: ["AuthDialogProvider"] */ "/vercel/path0/components/auth/AuthDialogContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExtractorNav"] */ "/vercel/path0/components/extractor/ExtractorNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalErrorBoundary"] */ "/vercel/path0/components/GlobalErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseProvider"] */ "/vercel/path0/components/providers/SupabaseProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@1.3.1_next@14.2.16_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1__react@18.3.1/node_modules/@vercel/analytics/dist/next/index.mjs");
